import React from 'react';
import Icon from '../../../components/AppIcon';

const GoalStats = ({ goals }) => {
  const formatIndianCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    })?.format(amount);
  };

  const calculateStats = () => {
    if (goals?.length === 0) {
      return {
        totalGoals: 0,
        totalTarget: 0,
        totalSavings: 0,
        averageProgress: 0,
        onTrackGoals: 0
      };
    }

    const totalTarget = goals?.reduce((sum, goal) => sum + goal?.targetAmount, 0);
    const totalSavings = goals?.reduce((sum, goal) => sum + goal?.currentSavings, 0);
    const averageProgress = (totalSavings / totalTarget) * 100;
    
    const onTrackGoals = goals?.filter(goal => {
      const progress = (goal?.currentSavings / goal?.targetAmount) * 100;
      const targetDate = new Date(goal.targetDate);
      const today = new Date();
      const totalMonths = (targetDate?.getFullYear() - new Date(goal.createdAt)?.getFullYear()) * 12 + 
                         (targetDate?.getMonth() - new Date(goal.createdAt)?.getMonth());
      const elapsedMonths = (today?.getFullYear() - new Date(goal.createdAt)?.getFullYear()) * 12 + 
                           (today?.getMonth() - new Date(goal.createdAt)?.getMonth());
      const expectedProgress = (elapsedMonths / totalMonths) * 100;
      
      return progress >= expectedProgress;
    })?.length;

    return {
      totalGoals: goals?.length,
      totalTarget,
      totalSavings,
      averageProgress,
      onTrackGoals
    };
  };

  const stats = calculateStats();

  const statCards = [
    {
      icon: 'Target',
      label: 'Total Goals',
      value: stats?.totalGoals?.toString(),
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      icon: 'TrendingUp',
      label: 'Target Amount',
      value: formatIndianCurrency(stats?.totalTarget),
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      icon: 'Wallet',
      label: 'Current Savings',
      value: formatIndianCurrency(stats?.totalSavings),
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      icon: 'Activity',
      label: 'Average Progress',
      value: `${stats?.averageProgress?.toFixed(1)}%`,
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      icon: 'CheckCircle2',
      label: 'On Track',
      value: `${stats?.onTrackGoals}/${stats?.totalGoals}`,
      color: 'text-emerald-600',
      bgColor: 'bg-emerald-100'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
      {statCards?.map((stat, index) => (
        <div key={index} className="bg-card rounded-xl border border-border p-4 hover:shadow-lg transition-all duration-300">
          <div className="flex items-center justify-between mb-3">
            <div className={`${stat?.bgColor} p-2 rounded-lg`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
          </div>
          <p className="text-sm text-muted-foreground mb-1">{stat?.label}</p>
          <p className={`text-xl font-bold ${stat?.color}`}>{stat?.value}</p>
        </div>
      ))}
    </div>
  );
};

export default GoalStats;